import React, { Component } from 'react';
// import { country } from './data';
// import './style';
import {
  CountryList,
  CountryBorder,
  NavBar,
  SearchIcon,
  FilterButton,
  BrandsListImg,
  BrandsListEn,
  BrandsListCn,
  TopDownload
} from './style';

import httpAxios from '../../http/httpAxios';
import api from '../../http/api';

const searchButton = require('../../images/search_button.svg')
const h5logo = require('../../images/h5logo.png');

// 头部搜索栏
class Pager extends Component {
  constructor() {
    super();
    this.state = {
      isTouching: false,
      lastChar: 'A',
      country: [],
      charStr: [],
      showTopDownload: true
    }

    // this.isTouching = false;
    this.boxClientTop = 148;
    // this.lastChar = 'A';
    this.touchStart = this.touchStart.bind(this);
    this.touchMove = this.touchMove.bind(this);
    this.touchEnd = this.touchEnd.bind(this);
    this.getChar = this.getChar.bind(this);
    this.gotoChar = this.gotoChar.bind(this);
  }

  touchStart(e) {
    this.setState({ isTouching: true });
    const char = this.getChar(e.touches[0].clientY);
    if (char) {
      this.gotoChar(char);
    }
  }
  touchMove(e) {
    e.preventDefault();
    const char = this.getChar(e.touches[0].clientY);
    if (char) {
      this.gotoChar(char);
    }
  }
  touchEnd(e) {
    e.preventDefault();
    this.setState({ isTouching: false });
  }
  getChar(clientY) {
    const charListBorder = document.querySelector('.char-list-border');
    const charBar = this.refs.charBar;
    if (!charBar || !charListBorder) return null;

    const charHeight = charBar.offsetHeight / this.state.charStr.length;
    const relativeY = clientY - charListBorder.offsetTop;
    const index = Math.floor(relativeY / charHeight);
    
    if (index >= 0 && index < this.state.charStr.length) {
      return this.state.charStr[index];
    }
    return null;
  }
  gotoChar(char) {
    if (!char || char === this.state.lastChar) {
      return false;
    }
    this.setState({ lastChar: char });

    if (char === '*') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (char === '#') {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    } else {
      const target = document.querySelector(`[data-en="${char}"]`);
      if (target) {
        const navHeight = document.querySelector('.nav-bar')?.offsetHeight || 0;
        const filterHeight = document.querySelector('.filter-button')?.offsetHeight || 0;
        const offset = target.offsetTop - (navHeight + filterHeight);
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }
  }
  componentWillMount() {
    // alert(JSON.stringify(this.country));    
  }

  componentDidMount() {
    // 判断是否在APP内
    const isInApp = typeof window.ReactNativeWebView !== 'undefined';
    this.setState({ showTopDownload: !isInApp });
    
    this.getBrands();

    // 添加视口高度调整监听
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    // 移除监听器
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    // 更新 boxClientTop 值以适应不同设备
    const navHeight = document.querySelector('.nav-bar')?.offsetHeight || 0;
    const filterHeight = document.querySelector('.filter-button')?.offsetHeight || 0;
    const topDownloadHeight = this.state.showTopDownload ? 56 : 0; // 3.5rem = 56px
    this.boxClientTop = navHeight + filterHeight + topDownloadHeight;
  }

  componentDidUpdate() {
    document.body.style.overflow = 'auto';
    //右上角按钮动作
    window.saveInfo = function () {
      window.ReactNativeWebView.postMessage(JSON.stringify({ 
        type: "share", 
        title: "品牌汇", 
        description: "中乐之声品牌汇，汇集众多优质音频品牌",
        webUrl: 'https://m.chinaaudio.net.cn/Brands',
        imageUrl: ''
      }))
    }
  }

  getBrands = async () => {
    const res = await httpAxios(api.getAppBrands, {});
    if (res) {
      this.setState(
        {
          charStr: res.Data.Letters,
          country: res.Data.Data
        }
      );
    }
  }
  render() {
    const {
      country,
      charStr,
      showTopDownload
    } = this.state;

    return (
      <>
        <CountryList>
          {showTopDownload && (
            <>
              <TopDownload>
                <img src={h5logo} alt="" />
                <a href={'https://a.app.qq.com/o/simple.jsp?pkgname=com.chinaauidonativeapp'} target='_blank'>
                  <div>打开App</div>
                </a>
              </TopDownload>
              <div style={{ height: '3.5rem' }} />{/* 占位高度 */}
            </>
          )}
          <NavBar className="nav-bar">
            <span>品牌汇</span>
            <div>
              <span 
                onClick={() => { 
                  window.ReactNativeWebView.postMessage(JSON.stringify({ 
                    type: "share", 
                    title: "品牌汇", 
                    description: "中乐之声品牌汇，汇集众多优质音频品牌",
                    webUrl: 'https://m.chinaaudio.net.cn/Brands',
                    imageUrl: ''
                  })) 
                }} 
                style={{ 
                  marginRight: '1.5rem',
                  width: '1.375rem',
                  height: '1.375rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="iconfont" style={{ color: '#333', fontSize: '1.375rem' }}>&#xe765;</i>
              </span>
              <SearchIcon onClick={() => { window.ReactNativeWebView.postMessage(JSON.stringify({ type: "searchnav", weburl: "/search" })) }}><img src={searchButton} alt="搜索" /></SearchIcon>
            </div>
          </NavBar>
          <FilterButton className="filter-button">
            <div onClick={() => { localStorage.setItem("_search", "真无线耳机,1"); window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: '真无线耳机', weburl: "/Brands/FilterResultList" })); }}>真无线耳机</div>
            <div onClick={() => { localStorage.setItem("_search", "落地音箱,1"); window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: '落地音箱', weburl: "/Brands/FilterResultList", search: "落地音箱,1" })); }}>落地音箱</div>
            <div onClick={() => { localStorage.setItem("_search", "美国,2"); window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: '美国', weburl: "/Brands/FilterResultList", search: "美国,2" })); }}>美国</div>
            {/* <div onClick={() => { localStorage.setItem("_search", "英国,2"); window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: '英国', weburl: "/Brands/FilterResultList", search: "英国,2" })); }}>英国</div> */}
            <span onClick={() => {
              //记录查询条件
              localStorage.removeItem("searchList");
              window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: '更多筛选条件', weburl: "/Brands/FilterResultList", model: true }));
            }}>更多筛选<i className='iconfont'>&#xe744;</i></span>
          </FilterButton>
          <div style={{ height: '9.25rem' }}></div>

          {/* <Detial>这是detail page</Detial> */}
          <CountryBorder ref="countryList" >
            {
              country.map((item, index) => {
                return (
                  <div key={index}>
                    <a onClick={() => { window.ReactNativeWebView.postMessage(JSON.stringify({ type: "detailnav", title: '品牌主页', weburl: '/Brands/BrandsDetail/' + item.ID })); }}>
                      {item.First && <div data-en={item.Letter}></div>}
                      <div
                        className={item.First === true ? "title" : 'brandsList'}
                      >
                        {!item.First && <BrandsListImg><img src={item.BrandLogo + '?x-oss-process=image/resize,w_92,m_lfit'} alt="" /></BrandsListImg>}
                        <BrandsListEn>{item.BrandName}</BrandsListEn>
                        {!item.First && <BrandsListCn>{item.BrandCountry}</BrandsListCn>}
                      </div>
                    </a>
                  </div>
                )
              })
            }
            <div className="char-list-border">
              <ul
                className="char-list"
                ref="charBar"
                onTouchStart={this.touchStart}
                onTouchMove={this.touchMove}
                onTouchEnd={this.touchEnd}
              >
                {
                  charStr.map((char, index) => {
                    return (
                      <li className="char-item" key={index}>{char}</li>
                    )
                  })
                }
              </ul>
            </div>
            {this.state.isTouching && <div className="char-tip">{this.state.lastChar}</div>}
          </CountryBorder>
        </CountryList>
      </>
    )
  }
}



export default Pager;
